import Vue from "vue"
import axios from "axios"
import {reactive, toRefs, provide, inject} from "@vue/composition-api"

export const state = reactive({})

export const actions = {
    fetchSubscriptionInfo(companyId) {
        return new Promise(function (resolve, reject) {
            let req_params = {}
            let url = Vue.config.url_prefix + "/api/a/{0}/subscription/info".format(companyId)
            axios
                .get(url, {params: req_params})
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    previewSubscription(companyId, payload) {
        return new Promise(function (resolve, reject) {
            let url = Vue.config.url_prefix + "/api/a/{0}/subscription/preview".format(companyId)
            axios
                .post(url, payload)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    deactivateCompany(companyId) {
        return new Promise(function (resolve, reject) {
            let url = Vue.config.url_prefix + "/api/a/{0}/subscription/deactivate".format(companyId)
            axios
                .post(url)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    adminFetchVouchers(params) {
        let url = Vue.config.url_prefix + "/api/admin/voucher"
        return new Promise((resolve, reject) => {
            axios
                .get(url, {params: params})
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    adminFetchVoucher(voucherId) {
        return new Promise((resolve, reject) => {
            axios
                .get(Vue.config.url_prefix + "/api/admin/voucher/{0}".format(voucherId))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    adminSaveVoucher(data) {
        return new Promise((resolve, reject) => {
            axios
                .post(Vue.config.url_prefix + "/api/admin/voucher", data)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    adminDeleteVoucher(voucherId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(Vue.config.url_prefix + "/api/admin/voucher/{0}".format(voucherId))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    }
}

export const key = Symbol("SubscriptionModule")

export const provideSubscription = () => {
    provide(key, {
        ...toRefs(state),
        ...actions
    })
}

export default () => inject(key)
